import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { userPrivileges } from '../../../apollo/cache';
import { useReactiveVar } from '@apollo/client';
import NotFoundPage from '../../notFound/NotfoundPage';
import NoPermissionsPage from '../../unauthorized/NoPermissionsPage.js';
import ReleaseNotesPage from '../../releaseNotes/components/ReleaseNotesPage';
import LandingPageWrapper from '../components/LandingPageWrapper';

const RoutesForDeactivatedUsers = () => {
  const privileges = useReactiveVar(userPrivileges);
  if (!privileges || !privileges.length) {
    return null;
  }

  return (
    <Routes>
      <Route path='/release-notes' element={<LandingPageWrapper page={ReleaseNotesPage} />} />
      <Route path='/' element={<Navigate to='/release-notes' replace />} />
      <Route path='/page-not-found' element={<NotFoundPage />} />

      <Route path='/permissions' element={<NoPermissionsPage />} />
      <Route path='*' element={<Navigate to='/page-not-found' replace />} />
    </Routes>
  );
};

export default RoutesForDeactivatedUsers;
